import { render, staticRenderFns } from "./detailsProgram.vue?vue&type=template&id=2b9d1ef9&scoped=true"
import script from "./detailsProgram.vue?vue&type=script&lang=js"
export * from "./detailsProgram.vue?vue&type=script&lang=js"
import style0 from "./detailsProgram.vue?vue&type=style&index=0&id=2b9d1ef9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d1ef9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9d1ef9')) {
      api.createRecord('2b9d1ef9', component.options)
    } else {
      api.reload('2b9d1ef9', component.options)
    }
    module.hot.accept("./detailsProgram.vue?vue&type=template&id=2b9d1ef9&scoped=true", function () {
      api.rerender('2b9d1ef9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programList/components/detailsProgram.vue"
export default component.exports